import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LitElementIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 73 73"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="currentColor"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <polygon
      id="Shape"
      points="32.3581395 37.2516279 10.9243256 0.126627907 21.6418605 0.126627907 43.0758837 37.2516279"
    />
    <polygon
      transform="translate(0.000000, 9.209302)"
      points="10.9243256 28.0423256 0.206581395 9.47972093 5.56597674 0.198418605 21.6418605 28.0423256 10.9241163 28.0423256"
    />
    <polygon
      transform="translate(5.441860, 0.000000)"
      points="5.48246512 18.6890233 0.124325581 9.40772093 5.48225581 0.126627907 10.8418605 9.40772093"
    />
    <polygon
      transform="translate(37.674419, 18.627907)"
      points="5.40125581 18.6237209 0.0418604651 9.3424186 5.40125581 0.0611162791 10.7593953 9.3424186 5.40125581 18.6237209"
    />
    <polygon
      transform="translate(32.232558, 0.000000)"
      points="16.2014651 27.9703256 0.125581395 0.126627907 10.8433256 0.126627907 21.5610698 18.6890233 16.2016744 27.9703256"
    />
  </svg>
)
const ForwardRef = forwardRef(LitElementIcon)
export { ForwardRef as ReactComponent }
